export default {
  common: {
    getDataFailed: '獲取數據失敗',
    cancel: '取消',
    noResult: '無結果',
    prize: '獎金',
    totalPrize: '總獎金',
    round: '輪次',
    time: '時間',
    address: '地址',
    type: '類型',
    options: '選項',
    none: '無',
    executedSuccessfully: '操作成功',
    point: '積分',
    points: '積分',
  },
  header: {
    referral: '推薦',
    connect: '連接錢包',
    records: '我的紀錄',
    register: '支付/質押',
    disconnect: '斷開連接',
    networkHint: '請注意您的網絡延遲',
  },
  rules: {
    top: '你準備好迎接挑戰了嗎？我們有12個問題，在一個回合中，獲獎者可以分享至少$10,000美元的獎金池。',
    title: '規則',
    section1: '報名截止時間為北京時間17:00，活動於北京時間17:05開始。',
    section2: '你需要質押Lifeform Cartoon Avatar並且支付500積分才能報名參加這項活動；如果你沒有Lifeform Cartoon Avatar，你需要支付20 USDT才能報名參加這項活動。',
    section3: '共有12個問題。對於一個問題，你有20秒的時間來選擇你的答案，而正確的答案將在剩下的5秒中顯示出來。如果你回答正確，就可繼續下一個問題。',
    section4: '當這一輪結束後，你可以取消質押。',
    section5: '每輪比賽結束後，獎品將空投給獲獎者。',
    section6: '發送推薦鏈接給你的朋友獲得復活卡。 [一旦他/她使用了你的鏈接並註冊了SuperAvatar活動，你將得到復活卡]。',
    section7: '你可以使用復活卡繼續遊戲。 每張復活卡每回合只提供一次機會。',
    section8: '未使用的復活卡將在每回合後自動失效。',
  },
  home: {
    prizePool: '獎池',
    totalParticipants: '參與人數',
    round: '輪次',
    startIn: '開始於',
    connect: '連接',
    register: '報名',
    registered: '已報名',
    enter: '進入',
    ongoing: '進行中',
    ended: '已結束',
    cumulativeRanking: '累計排名',
  },
  register: {
    registerRecords: '報名紀錄',
    registerForRound: '報名輪次',
    youCanChoose: '你可以選擇',
    pay: '支付',
    or: '或者',
    stake: '質押',
    staked: '已質押',
    paid: '已支付',
    inviteFriends: '邀請朋友',
    insufficientFunds: '餘額不足',
    registerSuccess: '報名成功',
    registerFail: '報名失敗',
    onceRegistered: '一旦報名成功後，你可以獲得本輪的Lifeform Cartoon紀念章',
    checkMyMedal: '查看我的紀念章',
    backToHome: '回到主頁',
    pointsNotEnough: '積分不足',
  },
  records: {
    myTotalPrize: '我的總獎金',
    myRecordsInSuperAvatar: '我在 SUPER AVATAR 的紀錄',
    round: '輪次',
    totalRegistered: '總報名人數',
    totalPrize: '總獎金',
    winners: '獲勝者',
    defeat: '擊敗',
    myPrize: '我的獎金',
    myRecordsOfPayStake: '我的支付/質押紀錄',
    checkStage1: '查看Super Avatar I',
    backToStage2: '回到Super Avatar II',
  },
  share: {
    share: '分享',
    referralUrlCopied: '已複製邀請鏈接',
    showItOff: '炫耀',
    invitingYouTo: '邀請你',
    theWinnersTakeAll: '獲勝者瓜分全部',
    yourReferralUrl: '你的推薦連接',
    downloadAndShare: '下載圖片分享',
    comeToWin: '來SUPER AVATAR獲得獎金！',
    iHaveDefeated: '我已擊敗',
    ofThePlayers1: '的玩家，',
    ofThePlayers2: '差一點就得到',
    isTheWinnerOfThisRound: '是這輪的獲勝者',
    hasWon: '已經贏得',
    comeToTogether: '一起來贏得更多獎金吧',
    hereRecordOf: '這裡是遊戲紀錄',
    knowMore: '了解更多關於SUPER AVATAR',
    iHaveWon: '我已贏得',
    everyDay: '每天',
    resurrectionCardUsed: '復活卡已使用',
    everyDay12GMTAAnswer: '每天 9AM（GMT），答對12題，立刻平分10000USDT，參與鏈接：',
    totalHighAs: '總獎池高達',
    everyDay12GMT: '每天 9AM GMT',
    answer12Today1: '答對12題，獲勝者平分當日所有獎金',
    answer12Today2: '',
    numIHaveDefeated: '我已擊敗',
    numOfThePlayers1: '名玩家，',
    numOfThePlayers2: '差一點就得到',
    holdDownShare: '長按圖片分享',
    win: '已賺取',
  },
  stake: {
    registerBuStaking: '使用質押報名',
    unstakeAllAvatar: '取消質押所有avatar',
    chooseyouravatar: '選擇你的avatar',
    stake: '質押',
    unstake: '取消質押',
    unstaked: '已經取消質押',
    approveToken: '請授權你的代幣用於註冊',
    approveNFT: '請授權你的NFT用於註冊',
  },
  match: {
    watching: '觀看中',
    sorryYouAreOut: '對不起，你出局了！',
    wishNext: '希望你在下局遊戲中獲得勝利！',
    totalPrize: '總奖金',
    survivedAndTotal: '存活/合計 報名',
    prizeForEach: '每人可得獎金',
    rememberTo: '記得',
    unstakeYourAvatar: '取消質押你的avatar',
    congrats: '祝賀!',
    areWinner: '你是這一輪的獲勝者！',
    almostWinner: '你差一點就成為獲勝者！',
    keepLearning: '保持學習，在下一輪獲勝！',
    toGetCard: '獲得下一輪的復活卡',
  },
  referral: {
    currentRound1: '現在是第',
    currentRound2: '輪',
    inviteYourFriendsTo: '邀請你的朋友來獲得這一輪的復活卡!',
    referralRecords: '推薦紀錄',
    round: '輪次',
    resurrectionCard: '復活卡',
    usedOrNot: '是否使用',
    invitedUsers: '被邀請的用戶',
    used: '已使用',
    unused: '未使用',
    none: '無',
    viewDetails: '查看詳情',
  }
};